<template>
  <dl class="tw-flex tw-gap-6 sf-below-2">
    <div>
      <dt class="tw-font-bold tw-inline">Ruby</dt>
      <dd class="tw-inline">{{ debugLog.metadata.rubyVersion }}</dd>
    </div>
    <div>
      <dt class="tw-font-bold tw-inline">Memory</dt>
      <dd class="tw-inline">
        {{ debugLog.metadata.initialMemoryMb }}MB &rarr;
        {{ debugLog.metadata.peakMemoryMb }}MB peak &rarr;
        {{ debugLog.metadata.finalMemoryMb }}MB final
      </dd>
    </div>
    <div>
      <dt class="tw-font-bold tw-inline">Duration</dt>
      <dd class="tw-inline">{{ debugLog.metadata.totalDurationSeconds }}s</dd>
    </div>
  </dl>

  <table v-if="debugLog.steps.length" class="sf-table sf-table-hover tw-w-full">
    <thead>
      <tr>
        <th>#</th>
        <th>Type</th>
        <th>Title</th>
        <th class="tw-text-right">Duration</th>
        <th class="tw-text-right">Memory &Delta;</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="step in debugLog.steps"
        :key="step.index"
        :class="{
          'sf-c-danger-light-1':
            step.status === 'running' || step.status === 'failed',
        }"
      >
        <td>{{ step.index }}</td>
        <td>{{ step.type }}</td>
        <td>
          {{ step.title }}
          <strong v-if="step.status === 'running'">(killed)</strong>
          <strong v-if="step.status === 'failed'">(failed)</strong>
        </td>
        <td class="tw-text-right">
          {{ step.status !== 'running' ? `${step.durationSeconds}s` : '—' }}
        </td>
        <td class="tw-text-right">
          {{ step.status !== 'running' ? `${step.memoryDeltaMb}MB` : '—' }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import type { DebugLog } from '@app/application/export/types'

defineOptions({
  name: 'ExportDebugLog',
})

interface Props {
  debugLog: DebugLog
}

defineProps<Props>()
</script>
